export default function numberToArray(input: number): any[] {
  const ret = [];
  for (let i = 0; i < input; i++) {
    ret.push(i);
  }
  return ret;
}
